import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import * as S from './styled'
import ImgBannerAbout from './ImgBannerAbout'
import ImgSectionAbout from './ImgSectionAbout'
import ImgBannerTwo from './ImgBannerTwo'
import Img from 'gatsby-image'
import ImgGenetic from '../BannerInstitutional/imgGenetic'
import { ArrowRight, ArrowLeft, ChevronRight } from '@dasa-health/alma-icons'
import SwiperCore, { Pagination, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.min.css'
import 'swiper/swiper-bundle.min.css'
import 'swiper/components/pagination/pagination.min.css'
import 'swiper/components/navigation/navigation.min.css'
import { ButtonDasa } from '../shared/ButtonDasa'
import { CardWithImg } from '../shared/CardWithImg'
import useIsBrazil from '../../utils/isBrazil'

SwiperCore.use([Pagination, Navigation])

const AboutPage = ({ data }) => {
  const { areas } = useStaticQuery(graphql`
    query {
      areas: allWordpressWpExpertiseAreaPage(sort: { fields: acf___ordem_desktop, order: ASC }) {
        edges {
          node {
            acf {
              description_area
              link_atuacao
              link_exames
              nome
              title_exam_contrast_1
              title_exam_contrast_2
              title_exam_contrast_3
              link_exam_contrast_1
              link_exam_contrast_2
              link_exam_contrast_3
              icone {
                alt_text
                localFile {
                  childImageSharp {
                    fluid(quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              ordem_desktop
            }
          }
        }
      }
    }
  `)

  const wordpressWpGatsbyPage = data
  const AreaItens = areas.edges

  const navigationPrevRef = React.useRef(null)
  const navigationNextRef = React.useRef(null)
  const titleDifferences = wordpressWpGatsbyPage[`title_section_difference`].split(' ')
  const isBrazil = useIsBrazil()

  const cards = Array.from({ length: 4 }, (_, i) => {
    const index = i + 1
    return {
      img: wordpressWpGatsbyPage[`about_img_card_${index}`],
      title: wordpressWpGatsbyPage[`about_title_card_${index}`],
      description: wordpressWpGatsbyPage[`about_description_card_${index}`],
    }
  })

  const textsPresence = Array.from({ length: 3 }, (_, i) => {
    const index = i + 1
    return {
      text_blue: wordpressWpGatsbyPage[`text_blue_phrase_${index}`],
      text_pink: wordpressWpGatsbyPage[`text_pink_phrase_${index}`],
      description: wordpressWpGatsbyPage[`text_description_phrase_${index}`],
    }
  })

  return (
    <>
      <S.AboutAndBackgroundContainer>
        <S.AboutContainer>
          <S.SubtitleContainer>
            <S.AboutSubtitle>
              <h1 dangerouslySetInnerHTML={{ __html: wordpressWpGatsbyPage.subtitle }} />
            </S.AboutSubtitle>

            <S.AboutSubtitleDescription>
              <p dangerouslySetInnerHTML={{ __html: wordpressWpGatsbyPage.demonstrative_text }} />
            </S.AboutSubtitleDescription>
            <S.ContainerButtonDasa>
              <ButtonDasa
                link={'/areas-de-atuacao'}
                text={
                  isBrazil ? 'Conheça nossas especialidades' : 'Descubre nuestras especialidades'
                }
              />
            </S.ContainerButtonDasa>
          </S.SubtitleContainer>
        </S.AboutContainer>

        <S.ImagePeoples>
          <ImgBannerAbout />
        </S.ImagePeoples>
      </S.AboutAndBackgroundContainer>

      <S.SectionContainerFullWidth>
        <S.SectionContainer>
          <S.ImageContainer>
            {wordpressWpGatsbyPage.img_banner_1_desk ? (
              <S.BannerOneDesk>
                <Img
                  fluid={wordpressWpGatsbyPage.img_banner_1_desk.localFile.childImageSharp.fluid}
                  alt={wordpressWpGatsbyPage.img_banner_1_desk.alt_text}
                />
              </S.BannerOneDesk>
            ) : (
              <ImgSectionAbout />
            )}

            {wordpressWpGatsbyPage.img_banner_1_mobile ? (
              <S.BannerOneMobile>
                <Img
                  fluid={wordpressWpGatsbyPage.img_banner_1_mobile.localFile.childImageSharp.fluid}
                  alt={wordpressWpGatsbyPage.img_banner_1_mobile.alt_text}
                />
              </S.BannerOneMobile>
            ) : (
              <ImgSectionAbout />
            )}
          </S.ImageContainer>

          <S.SectionAbout>
            <S.SectionContent>
              <S.AboutDescriptionContent>
                <S.ImageTitle>
                  <h2 dangerouslySetInnerHTML={{ __html: wordpressWpGatsbyPage.title_banner_1 }} />
                </S.ImageTitle>

                <S.ImageDescription>
                  <div
                    dangerouslySetInnerHTML={{ __html: wordpressWpGatsbyPage.description_banner_1 }}
                  />
                </S.ImageDescription>
              </S.AboutDescriptionContent>
              <S.ContainerButtonDasa>
                <ButtonDasa
                  link={'/areas-de-atuacao'}
                  text={isBrazil ? 'Áreas de atuação' : 'Áreas de actividad'}
                />
              </S.ContainerButtonDasa>
            </S.SectionContent>
          </S.SectionAbout>
        </S.SectionContainer>
      </S.SectionContainerFullWidth>

      <S.ContainerDifferencesFullWidth>
        <S.ContainerDifferences>
          <S.TitleDifferences>
            {titleDifferences[0]} <span>{titleDifferences[1]}</span>
          </S.TitleDifferences>
          <S.ContentDifferences>
            {cards.map(card => (
              <CardWithImg
                img={card.img.localFile.childImageSharp.fluid}
                title={card.title}
                description={card.description}
              />
            ))}
          </S.ContentDifferences>
        </S.ContainerDifferences>
      </S.ContainerDifferencesFullWidth>

      <S.BannerTwoContainerFullWidth>
        <S.BannerTwoContainer>
          <S.BannerTwoContent>
            <S.BannerTwoTitle>{wordpressWpGatsbyPage.title_banner_2}</S.BannerTwoTitle>

            <S.BannerTwoDescription>
              {wordpressWpGatsbyPage.description_banner_2}
            </S.BannerTwoDescription>
          </S.BannerTwoContent>

          <S.BannerTwoImg>
            {wordpressWpGatsbyPage.img_banner_2_desk ? (
              <S.BannerTwoDesk>
                <Img
                  fluid={wordpressWpGatsbyPage.img_banner_2_desk.localFile.childImageSharp.fluid}
                  alt={wordpressWpGatsbyPage.img_banner_2_desk.alt_text}
                />
              </S.BannerTwoDesk>
            ) : (
              <ImgBannerTwo />
            )}

            {wordpressWpGatsbyPage.img_banner_2_mobile ? (
              <S.BannerTwoMobile>
                <Img
                  fluid={wordpressWpGatsbyPage.img_banner_2_mobile.localFile.childImageSharp.fluid}
                  alt={wordpressWpGatsbyPage.img_banner_2_mobile.alt_text}
                />
              </S.BannerTwoMobile>
            ) : (
              <ImgBannerTwo />
            )}
          </S.BannerTwoImg>
        </S.BannerTwoContainer>
      </S.BannerTwoContainerFullWidth>

      <S.AreasContainerFullWidth>
        <S.AreasContainer>
          <S.AreasContent>
            <S.ImgGenetic>
              <ImgGenetic />
            </S.ImgGenetic>

            <S.AreasTitle>
              {wordpressWpGatsbyPage.title_areas} <br></br>
            </S.AreasTitle>

            <S.AreasDescription>{wordpressWpGatsbyPage.description_areas}</S.AreasDescription>
          </S.AreasContent>

          <S.CarouselAreasContainer>
            <Swiper
              spaceBetween={0}
              slidesPerView={'auto'}
              grabCursor={true}
              modules={[Pagination, Navigation]}
              navigation={{
                prevEl: navigationPrevRef.current,
                nextEl: navigationNextRef.current,
              }}
              onBeforeInit={swiper => {
                swiper.params.navigation.prevEl = navigationPrevRef.current
                swiper.params.navigation.nextEl = navigationNextRef.current
              }}
              pagination={{
                clickable: true,
              }}
            >
              {AreaItens.map(item => (
                <SwiperSlide key={item.toString()}>
                  <S.AreaItem>
                    <S.AreaIcon>
                      <Img
                        fluid={item.node.acf.icone.localFile.childImageSharp.fluid}
                        alt={item.node.acf.icone.alt_text}
                      />
                    </S.AreaIcon>

                    <S.AreaTitleLink to={item.node.acf.link_atuacao}>
                      <S.AreaTitle>{item.node.acf.nome}</S.AreaTitle>
                    </S.AreaTitleLink>

                    <S.AreaLinks>
                      <S.DivAreaTextLink>
                        {Array.from({ length: 3 }).map((_, index, arr) => {
                          const link = item.node.acf[`link_exam_contrast_${index + 1}`]
                          const title = item.node.acf[`title_exam_contrast_${index + 1}`]

                          return (
                            <a
                              key={index}
                              href={link}
                              style={{
                                marginBottom: index === arr.length - 1 ? '1.6rem' : '0',
                                display: 'inline-block',
                              }}
                            >
                              <S.AreaTextLink>{title}</S.AreaTextLink>
                            </a>
                          )
                        })}
                      </S.DivAreaTextLink>

                      <S.AreaAllExams to={item.node.acf.link_exames}>
                        {wordpressWpGatsbyPage.carousel_allExams_btn_desk}

                        <ChevronRight />
                      </S.AreaAllExams>

                     {/*  <S.AreaAllExamsMobile to={item.node.acf.link_exames}>
                        {wordpressWpGatsbyPage.carousel_allExams_btn_mobile}
                      </S.AreaAllExamsMobile> */}
                    </S.AreaLinks>
                  </S.AreaItem>
                </SwiperSlide>
              ))}

              <SwiperSlide className="swiper-filler"></SwiperSlide>

              <S.NavigationContainer>
                <S.BtnNavigationPrev ref={navigationPrevRef}>
                  <ArrowLeft />
                </S.BtnNavigationPrev>

                <S.BtnNavigationNext ref={navigationNextRef}>
                  <ArrowRight />
                </S.BtnNavigationNext>
              </S.NavigationContainer>
            </Swiper>
            <S.ContainerButtonDasa>
              <ButtonDasa
                link={'/areas-de-atuacao'}
                text={
                  isBrazil ? 'Conheça nossas especialidades' : 'Descubre nuestras especialidades'
                }
              />
            </S.ContainerButtonDasa>
          </S.CarouselAreasContainer>
        </S.AreasContainer>
      </S.AreasContainerFullWidth>

      <S.DivPresence>
        <S.ContainerPresence>
          <S.TitlePresence>{wordpressWpGatsbyPage[`title_section_presence`]}</S.TitlePresence>
          {/* <S.BrandNumbersList>
          <BrandNumbers
            field="countries"
            stateNumber={wordpressWpGatsbyPage.countries_present_qtd}
            stateTitle={wordpressWpGatsbyPage.countries_present_title}
          />
          <BrandNumbers
            field="exams"
            stateNumber={wordpressWpGatsbyPage.exams_number}
            stateTitle={wordpressWpGatsbyPage.exams_title}
          />
          <BrandNumbers
            field="units"
            stateNumber={wordpressWpGatsbyPage.units_number}
            stateTitle={wordpressWpGatsbyPage.units_title}
          />
          <BrandNumbers
            field="partners"
            stateNumber={wordpressWpGatsbyPage.partners_number}
            stateTitle={wordpressWpGatsbyPage.partners_title}
          />
          <BrandNumbers
            field="self_collection_exams"
            stateNumber={wordpressWpGatsbyPage.self_collection_exams_qtd}
            stateTitle={wordpressWpGatsbyPage.self_collection_exams_title}
          />
        </S.BrandNumbersList> */}

          <S.ContentPresence>
            {textsPresence.map((text, index) => {
              return index === 2 ? (
                <S.ContainerTextPresence>
                  <S.TitlePresenceBrand>
                    {text.text_blue} <span>{text.text_pink}</span>{' '}
                  </S.TitlePresenceBrand>
                  <S.DescriptionPresenceBrand>{text.description}</S.DescriptionPresenceBrand>
                </S.ContainerTextPresence>
              ) : (
                <S.ContainerTextPresence>
                  <S.TitlePresenceBrand>
                    <span>{text.text_pink}</span>&nbsp;&nbsp;
                    {text.text_blue}
                  </S.TitlePresenceBrand>
                  <S.DescriptionPresenceBrand>{text.description}</S.DescriptionPresenceBrand>
                </S.ContainerTextPresence>
              )
            })}
          </S.ContentPresence>
        </S.ContainerPresence>
      </S.DivPresence>

      {/*  <S.ImagesGallery>
        <S.ImageOne>
          <Img
            fluid={wordpressWpGatsbyPage.image_1.localFile.childImageSharp.fluid}
            alt={wordpressWpGatsbyPage.image_1.alt_text}
          />
        </S.ImageOne>

        <S.ImageTwo>
          <Img
            fluid={wordpressWpGatsbyPage.image_2.localFile.childImageSharp.fluid}
            alt={wordpressWpGatsbyPage.image_2.alt_text}
          />
        </S.ImageTwo>

        <S.ImageThree>
          <Img
            fluid={wordpressWpGatsbyPage.image_3.localFile.childImageSharp.fluid}
            alt={wordpressWpGatsbyPage.image_3.alt_text}
          />
        </S.ImageThree>

        <S.ImageFour>
          <Img
            fluid={wordpressWpGatsbyPage.image_4.localFile.childImageSharp.fluid}
            alt={wordpressWpGatsbyPage.image_4.alt_text}
          />
        </S.ImageFour>
      </S.ImagesGallery> */}

      {isBrazil && wordpressWpGatsbyPage.video1.localFile.publicURL ? (
        <S.ContainerVideosDasa>
          {/* eslint-disable jsx-a11y/media-has-caption */}
          <video controls width="100%">
            <source
              src={wordpressWpGatsbyPage.video1.localFile.publicURL}
              type={wordpressWpGatsbyPage.video1.mime_type}
            />
            Seu navegador não suporta vídeos.
          </video>
        </S.ContainerVideosDasa>
      ) : null}
      <S.BlueBackground />
    </>
  )
}
export default AboutPage
